import req from "../http";

// 發送信件
const onBoard = {
  // 依據 MatchId 取得報到未到分類選項
  getNotArrivedCategory(matchId) {
    return req("get", `/Recruitment/OnBoard/NotArrivedCategory/${matchId}`);
  },

  // 依據 MatchId 取得報到狀態資訊
  getOnBoardStatus(MatchId) {
    return req("get", `/Recruitment/OnBoard/${MatchId}`);
  },

  // 取得 圖檔(報到資料)
  getImages(matchId) {
    return req("get", `/Recruitment/OnBoardImage/${matchId}`);
  },

  // 更新 圖檔(報到資料)
  putImages(params) {
    return req("put", "/Recruitment/OnBoardImage", params);
  },
};

export default onBoard;